import {authAxios} from "../api/axiosClient";
import {listCaLamViecURL} from "../constants";

const CaLamViecApi = (params={})=>{
        const url = listCaLamViecURL;
        return authAxios().get(url,{params});
}

export default CaLamViecApi;

export const PostCaLamApi = (params={})=>{
        const url = listCaLamViecURL;
        return authAxios().post(url,params);
}

export const PutCaLamApi = (params={})=>{
        const url = listCaLamViecURL;
        return authAxios().put(url,params);
}